import { IQuestionModel } from '@care-portals/api-interfaces';

const questionsModels: IQuestionModel[] = [
  /**
   * Hair forms
   */
  {
    label: 'Please upload a few images of your hair.',
    field: 'hairPhotos',
    type: 'file_upload',
    answer: [
      {
        resourceId: 'frontHair',
        label: 'Front Hairline',
        buttonLabel: 'Front hairline',
        defaultImage: 'frontHair.png'
      },
      {
        resourceId: 'backHair',
        label: 'Back Hairline',
        buttonLabel: 'Back hairline',
        defaultImage: 'backHair.png'
      },
      {
        resourceId: 'topHair',
        label: 'Top of Head',
        buttonLabel: 'Top of head',
        defaultImage: 'topHair.png'
      }
    ]
  },
  {
    label: 'How long ago did you first start to notice hair loss?',
    field: 'hair1',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'none', value: 'None, looking for a prevention regimen' },
        { key: 'year', value: 'A year or more' },
        { key: 'more6Months', value: 'More than 6 months' },
        {
          key: 'less6Months',
          value: 'Less than 6 months',
          answer: {
            type: 'text',
            name: 'less6MonthsDesc',
            placeholder:
              'Since you’ve indicated that your hair loss has been recent, please provide details about your hair loss circumstances - Any lifestyle/medical factors such as stress, health issues?'
          }
        }
      ]
    }
  },
  {
    label:
      'During your hair loss process have you experienced any of the following',
    field: 'hair2',
    type: 'select',
    required: true,
    answer: {
      type: 'multi_select',
      options: [
        { key: 'rings', value: 'Red Rings' },
        { key: 'redness', value: 'Redness/Irritation' },
        { key: 'itching', value: 'Itching' },
        { key: 'dandruff', value: 'Severe Dandruff' },
        { key: 'pain', value: 'Pain or burning sensation on or near scalp' },
        {
          key: 'body',
          value: 'Hair loss on other areas of your body (including your beard)'
        },
        {
          key: 'other',
          value:
            'Please list anything else you feel may be valuable for the doctor evaluating your submission',
          answer: {
            type: 'text',
            name: 'issuesOtherDesc',
            placeholder:
              'Please list all treatments you tried and let us know how your experience was and if you are still using them.'
          }
        },
        {
          key: 'none',
          value: 'None',
          uncheckOthers: true
        }
      ]
    }
  },
  {
    label:
      'Are you now, or have you in the past used any treatments, prescription or over the counter to try and prevent/slowdown/reverse hair loss?',
    field: 'hair3',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        { key: 'no', value: 'No' },
        {
          key: 'yes',
          value: 'Yes',
          answer: {
            label:
              'Please list all treatments you tried and let us know how your experience was and if you are still using them.',
            type: 'text_list',
            inputPlaceholder: 'Treatment Name'
          }
        }
      ]
    }
  },
  {
    label:
      'Have you ever had any issues such as Psoriasis or Eczema or any irritation on your scalp or other areas of your body?',
    field: 'hair4',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'irritationsYes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'irritationsDesc',
            placeholder:
              'Please explain your experience and if you were ever evaluated or sought treatment for the issue.'
          }
        },
        { key: 'irritationsNo', value: 'No' }
      ]
    }
  },
  {
    label: 'Do other members of your family have hair loss?',
    field: 'hair5',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'familyYes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'familyDesc',
            placeholder: 'Please list the relatives (parents , siblings etc.)'
          }
        },
        { key: 'familyNo', value: 'No' }
      ]
    }
  },
  {
    label:
      'Do you have any form of Sexual Dysfunction? Sexual Dysfunction can include issues with loss of sex drive and other symptoms:',
    field: 'hair6',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'sexualDysfunctionYes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'sexualDysfunctionDesc',
            placeholder:
              'Please tell us about your situation and if you have sought treatment'
          }
        },
        { key: 'sexualDysfunctionNo', value: 'No' }
      ]
    }
  },
  {
    label:
      'Do you have any diagnosed Mental Health conditions? Or do you have any depression or anxiety symptoms at any time?',
    field: 'hair7',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'mentalYes',
          value: 'Yes',
          answer: {
            type: 'text',
            name: 'mentalDesc',
            placeholder:
              'Please explain to the best of your ability and let us know if you are or have sought professional help including any medications'
          }
        },
        { key: 'mentalNo', value: 'No' }
      ]
    }
  },
  {
    label:
      'Any other information that you feel may be beneficial to the medical team evaluating your case?',
    field: 'hair8',
    type: 'info',
    answer: {
      type: 'text',
      placeholder: 'Please describe'
    }
  },
  {
    // 2
    label: 'Does any of the following apply to you ?',
    field: 'hairpregnant',
    type: 'info',
    required: false,
    answer: {
      type: 'list',
      items: [
        {
          label: 'Pregnant ?',
          type: 'single_select',
          options: [
            { key: 'yesPregnant', value: 'Yes' },
            { key: 'noPregnant', value: 'No' }
          ]
        },
        {
          label: 'Trying to Conceive ?',
          type: 'single_select',
          options: [
            { key: 'yesConceive', value: 'Yes' },
            { key: 'noConceive', value: 'No' }
          ]
        },
        {
          label: 'Breastfeeding ?',
          type: 'single_select',
          options: [
            { key: 'yesBreastfeeding', value: 'Yes' },
            { key: 'noBreastfeeding', value: 'No' }
          ]
        }
      ]
    }
  },
  {
    field: 'hairAcknowledgement3',
    label:
      'Some of our hair loss medications contain finasteride or tretinoin. These medications can affect fetal development. They are safe to use if you1re using appropriate contraception or are post-menopausal. ',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'hairAcknowledgement3',
          value: 'I understand and agree to use contraception if necessary.'
        }
      ]
    }
  },
  {
    field: 'hairAcknowledgement',
    label:
      'I agree to have my relevant prescription information transferred to IHS Compounding Pharmacy. The information shared will be kept strictly confidential in accordance with the Ontario College of Pharmacists` regulations.',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [{ key: 'hairAcknowledgement', value: 'I Agree' }]
    }
  },
  {
    field: 'hairAcknowledgement2',
    label:
      'Please be aware that women who can or are looking to become pregnant should avoid handling crushed or broken tablets of finasteride. Finasteride is harmful to fetuses. Caution should be used to prevent women from absorbing any finasteride through their skin or via accidental ingestion. Trace amounts of finasteride may be found in semen of men taking oral or using topical finasteride. There is unlikely to be a risk to a developing fetus when finasteride is used by a male partner as the amount of finasteride found in semen is very small. Furthermore this effect is less probable with topical medication, although this is assumed based on the reduced systemic (bloodstream) absorption with topical products. ',
    type: 'select',
    answer: {
      type: 'single_select',
      options: [
        {
          key: 'hairAcknowledgement2',
          value:
            'I have reviewed this caution and will consult with my healthcare team for any specific concerns I have'
        }
      ]
    }
  }
];

export default questionsModels;
